export { GOOGLE_API_KEY } from 'app/util/constants';

export const selectClassName = 'GooglePlacesInput--select-container';
